import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinRand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCoinRand"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.59961 11.0996H7.09961V12.9004H8.59961V16.5H10.4004V11.1357L13.4824 16.1699L13.7461 16.5996H15.4004V12.9004H16.9004V11.0996H15.4004V7.5H13.5996V12.9141L10.5176 7.87988L10.2539 7.4502H8.59961V11.0996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinRand;
